export default __webpack_public_path__ + "CZI.png";